import * as React from 'react';
import { t } from 'ttag';
import Popup from '../shared_component/Popup';

const Failed = () => (
  <Popup title={t`Oops…! Something went wrong`}>
    <span>{t`Try again after some time.`}</span>
  </Popup>
);

export default Failed;
